import {
  isCustomWindow,
  type ReportCompareValue,
  type ReportWidgetFilters,
  type ReportWindow
} from "../types/canvas.types.ts"
import { DEFAULT_REPORT_WINDOW } from "./reportDefinition.ts"
import { buildWidgetFilterPayload } from "./reportWidgetFilters.ts"

// Mirrors the dashboard's window param names (window / start / end) so a report
// resolve hits the same backend contract; falls back to the default preset when
// the definition carries no window yet.
const buildReportWindowParams = (
  window: ReportWindow | undefined
): Record<string, string> => {
  const effective = window ?? DEFAULT_REPORT_WINDOW
  if (isCustomWindow(effective))
    return { window: "custom", start: effective.from, end: effective.to }
  return { window: effective.preset }
}

const buildReportCompareParam = (
  compare: ReportCompareValue | undefined
): Record<string, string> => (compare ? { compare } : {})

interface ReportResolveContext {
  window?: ReportWindow
  compare?: ReportCompareValue
  filters?: ReportWidgetFilters
}

const buildReportResolveParams = ({
  window,
  compare,
  filters
}: ReportResolveContext): Record<string, string> => ({
  ...buildReportWindowParams(window),
  ...buildReportCompareParam(compare),
  ...buildWidgetFilterPayload(filters)
})

export {
  buildReportWindowParams,
  buildReportCompareParam,
  buildReportResolveParams,
  type ReportResolveContext
}
